import { Context, createContext } from 'preact';
import { useCallback, useContext, useEffect, useMemo, useState } from 'preact/hooks';
import { Services } from '@/services/services';

export const ServicesContext = createContext<Services | null>(null);

export const ServicesProvider = ({ services, children }: { services: Services, children: preact.ComponentChildren }) => {
    return (
        <ServicesContext.Provider value={services}>
            {children}
        </ServicesContext.Provider>
    );
};

export function useServices(keys: string[] = []): Services {
    const [_key, setKey] = useState(0);
    const services = useContext(ServicesContext)!;
    const listener = useCallback(() => {
        setKey((prev) => prev + 1);
    }, [services]);

    useEffect(() => {
        for (const key of keys) {
            services.context.addListener(key, listener);
        }

        return () => {
            for (const key of keys) {
                services.context.removeListener(key, listener);
            }
        };
    }, [services, listener, keys.join('|')]);

    return services;
}